/**
 * Keys stripped from Dreamdata cookieless track payloads. Cookieless is intended for
 * IP-to-company attribution / funnel metrics only - never direct identifiers.
 * Standard (consented) pipeline continues to receive full Segment props.
 */
export const COOKIELESS_PII_KEYS = [
  'email',
  'firstName',
  'lastName',
  'phone',
  'companyName',
  'company',
];

/**
 * Returns a shallow copy of props with known PII keys removed. Does not mutate the input.
 * Nested blobs are not expected on Signup Submitted today; if present they are left as-is
 * unless the top-level key itself is listed above.
 */
function sanitizeCookielessTrackProps(props) {
  if (!props || typeof props !== 'object') {
    return props;
  }

  const sanitized = { ...props };
  COOKIELESS_PII_KEYS.forEach((key) => {
    delete sanitized[key];
  });
  return sanitized;
}

export default sanitizeCookielessTrackProps;
